<template>
  <Slide class="FeaturesOfInterestSlide"
    v-bind="{ isCurrentSlide, isStartingSlide, mayContinue }"
    :title="content.title"
    nextAction="nextSlide"
  >
    <MultiOptionSelect
      name="inseegoFleetFeaturesOfInterest"
      v-bind="{ error, optionIcons }"
      :prompt="content.prompt"
      :options="content.options"
      :value="fieldValues.inseegoFleetFeaturesOfInterest"
      :disabled="!isCurrentSlide"
      @selectionChange="doUpdateField"
    />
  </Slide>
</template>

<script>
import { multiOptionSelectSlideMixin } from '../util/slideBuilders.js'

import MultiOptionSelect from './elems/MultiOptionSelect.vue'
import Slide from './elems/Slide.vue'

import featuresTelematics from  '../assets/option-icons/features-telematics.svg'
import featuresDashcams from  '../assets/option-icons/features-dashcams.svg'
import featuresDriverManagement from  '../assets/option-icons/features-driver-management.svg'
import featuresAssets from  '../assets/option-icons/features-assets.svg'
import featuresCompliance from  '../assets/option-icons/features-compliance.svg'
import featuresFuelTax from  '../assets/option-icons/features-fuel-tax.svg'
import featuresScheduling from  '../assets/option-icons/features-scheduling.svg'
import featuresRegistration from  '../assets/option-icons/features-registration.svg'
import featuresTachograph from  '../assets/option-icons/features-tachograph.svg'

const optionIcons = {
  'Vehicle tracking & telematics': featuresTelematics,
  'Dash cams': featuresDashcams,
  'Driver monitoring & management': featuresDriverManagement,
  'Asset tracking & management': featuresAssets,
  'Compliance': featuresCompliance,
  'Fuel tax management': featuresFuelTax,
  'Routing & scheduling': featuresScheduling,
  'Trip & time registration': featuresRegistration,
  'Digital tachograph': featuresTachograph,
}

export default {
  mixins: [multiOptionSelectSlideMixin],
  components: {
    MultiOptionSelect,
    Slide,
  },
  data() {
    return {
      fieldName: 'inseegoFleetFeaturesOfInterest',
      optionIcons,
    }
  },
}
</script>
